<template>
  <div>
    <canvas id="canvas"  :height="height"></canvas>
  </div>
</template>

<script>
import chartjs from 'chart.js'

function drawChart(self) {
		//this.$emit('draw chart')
		var ctx = document.getElementById('canvas').getContext('2d');

		var config = {
			type: 'bar',
			data: {
				datasets: self.datasets
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				title: {
					display: false
				},
				legend:{
					position: 'bottom'
				},
				scales: {
					xAxes: [{
						type: 'time',
						stacked: true,
            time: {
            unit:'day',
              displayFormats: {
                'day': 'DD MMM',
                'week': 'DD MMM',
                'month': 'DD MMM',
                'quarter': 'DD MMM',
                'year': 'DD MMMD',
              },
            },
						display: true,
						scaleLabel: {
							display: true,
							labelString: 'Date'
						},
						ticks: {
							major: {
								fontStyle: 'bold',
								fontColor: '#FF0000'
							}
						}
					}],
					yAxes: [{
						stacked: true,
						display: true,
						scaleLabel: {
							display: true,
							labelString: 'value'
						}
					}]
				}
			}
		};
		window.myChart = new Chart(ctx, config);
}

export default {
	props: ['height', 'datasets'],
  data: function() {
    return {
    }
	},
  mounted() {
		this.$emit('mounted')
		drawChart(this);
	},
	watch: {
		datasets: function(newVal, oldVal) {
			this.$emit('data changed')
			window.myChart.data.datasets = this.datasets;
			window.myChart.update()
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/LineChart.vue